import DailyMockBannerListPage from "./DailyMockBannerListPage";

export default function DailyMockBanner() {
  return <DailyMockBannerListPage />;
}
